import { OptionGroup, Theme } from '@infotech-soe/erp-ui-kit';
import React, { memo, useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import {
  TOTALS_FORMULA_ATTACHMENT,
  TOTALS_FORMULA_TYPE,
} from '../../../../models/user-config/DisplayModeConfig';
import { useAppSelector } from '../../../../store/hooks';
import { getDatasetConfigCurrentPreset } from '../../../../store/selectors/dataset';

import TotalsCell from './TotalsCell';

interface TotalsFormProps {
  datasetId: string;
}

export interface TotalsCellListItem {
  title?: string;
  attachment: TOTALS_FORMULA_ATTACHMENT;
  formula: TOTALS_FORMULA_TYPE;
  value: number;
}

const messages = defineMessages({
  totalsTitle: {
    id: 'core.category.grid.totals.title',
    defaultMessage: 'Totals',
  },
});

const useStyles = createUseStyles(({ colors }: Theme) => ({
  totalsLabel: {
    composes: 'm-pa-md',
    fontWeight: 'bold',
  },
  totals: {
    composes: 'm-px-md row no-wrap items-center',
    color: colors.typoCommon,
  },
}));

const TotalsForm: React.FC<TotalsFormProps> = ({ datasetId }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { totals: totalsConfig } = useAppSelector(state =>
    getDatasetConfigCurrentPreset(state, datasetId)
  );

  const TotalsCellFields = useMemo(
    () =>
      totalsConfig
        ? Object.keys(totalsConfig).map((field, index, arr) => (
            <TotalsCell
              datasetId={datasetId}
              field={field}
              key={field}
              last={index === arr.length - 1}
            />
          ))
        : undefined,
    [datasetId, totalsConfig]
  );

  if (!TotalsCellFields?.length) {
    return null;
  }

  return (
    <div className={classes.totals}>
      <div className={classes.totalsLabel}>
        {formatMessage(messages.totalsTitle)}
      </div>
      <OptionGroup noWrap withArrows>
        {TotalsCellFields}
      </OptionGroup>
    </div>
  );
};

export default memo(TotalsForm);
